import { render, staticRenderFns } from "./test-template-edit.vue?vue&type=template&id=0cb43b38&scoped=true&"
import script from "./test-template-edit.vue?vue&type=script&lang=ts&"
export * from "./test-template-edit.vue?vue&type=script&lang=ts&"
import style0 from "./test-template-edit.vue?vue&type=style&index=0&id=0cb43b38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb43b38",
  null
  
)

export default component.exports